import TrackeableEvent from './TrackeableEvent';

class MultipleEventTracker {
  constructor() {
    this.trackers = [];
  }
  start = async (id, ...rest) => {
    if (!this.trackers[id]) {
      const tracker = new TrackeableEvent();
      this.trackers[id] = tracker;
    }
    this.trackers[id].start(...rest);
  };
  end = async (id, ...rest) => {
    if (!this.trackers[id]) {
      console.log('[MultipleEventTracker] Not found tracker event instance');
      return;
    }
    this.trackers[id].end(...rest);
    delete this.trackers[id];
  };
}

export default MultipleEventTracker;
